<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-suspension-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Suspension',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreSuspensionView: () => import('../components/core/SuspensionView.vue'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
  }),
}
</script>
